<template>
    <div id="Section-08" class="section-08 wsl-flex-center-ng">
        <div class="container">
            <div class="wsl-w-100 wsl-h-100 wsl-relative">
                <div class="wsl-abs wsl-hide-sm wsl-hide-xs"
                     :style="{backgroundImage: `url(${blueBox})}`}"
                     style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    top: 0; right: 0; width: 33.34%; height: 5%;">
                </div>

                <div class="wsl-flex-ng">
                    <div class="wsl-col-4 wsl-hide-sm wsl-hide-xs wsl-relative"
                         :style="{backgroundImage: `url(${blueBox})}`}"
                         style="
                    background-color: #4fb8fe;
                    background-repeat: no-repeat;
                    background-size: cover;
                    background-position: center center;
                    padding-top: 6.3%;">
                        <div class="wsl-flex-ng">
                            <div class="padding-testimonials"></div>
                            <div class="wsl-col">
                                <div class="" style="line-height: 1.2">
                                    <span class="Oswald-Light cb-cyan t48">Остались вопросы?</span><br>
                                    <span class="Oswald-Light cb-white t48">Мы будем рады</span><br>
                                    <span class="Oswald-Light cb-white t48">пообщаться с вами</span>
                                </div>
                                <form id="call_form"
                                      novalidate="true">
                                    <div class="wsl-m-t-90">
                                        <div class="wsl-relative wsl-inline-block">
                                            <input id="name"
                                                   placeholder="Имя"
                                                   v-model="name"
                                                   v-on:input="hideError('name')"
                                                   :disabled="pending"
                                                   :readonly="pending"
                                                   type="text"
                                                   name="name">
                                            <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                                  v-if="errors.has('name')">{{errors.get('name')}}</span>
                                        </div>
                                        <div class="wsl-relative wsl-inline-block wsl-m-t-20">
                                            <masked-input
                                                    type="text"
                                                    placeholder="+7 ( ___ ) ___ - __ - __"
                                                    name="phone"
                                                    class=""
                                                    v-model="phone"
                                                    :mask="['+','7',' ','(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/,'-', /\d/, /\d/]"
                                                    :guide="true"
                                                    placeholderChar="_">
                                            </masked-input>
                                            <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                                  v-if="errors.has('phone')">{{errors.get('phone')}}</span>
                                        </div>
                                        <div class="wsl-relative wsl-inline-block wsl-m-t-20">
                                            <v-autocomplete :items="towns"
                                                            v-model="town"
                                                            :input-attrs="{
                                                            placeholder: 'Город',
                                                            id: 'town',
                                                            class: '',
                                                            name: 'town',
                                                            type: 'text',
                                                            disabled: pending,
                                                            readonly: pending
                                                          }"
                                                            :get-label="getLabel"
                                                            :auto-select-one-item="false"
                                                            :wait="350"
                                                            :min-len="0"
                                                            @change="changeTown"
                                                            @update-items="updateItems">
                                            </v-autocomplete>
                                            <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                                  v-if="errors.has('town')">{{errors.get('town')}}</span>
                                        </div>
                                    </div>

                                    <div class="wsl-small wsl-abs wsl-abs-left wsl-abs-bottom wsl-m-a-10">
                                        This site is protected by reCAPTCHA and the Google
                                        <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a>
                                        and
                                        <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a>
                                        apply.
                                    </div>
                                    <div class="wsl-m-b-50 wsl-flex-center-ng" style="margin-top: 110px; width: 256px;">
                                        <div class="cb-btn-submit wsl-inline-block wsl-text-center"
                                             style="" v-on:click="submit"
                                             :class="{onclick: pending, validate: sended}">
                                            <span class="order">Заказать звонок</span>
                                            <span class="success">Отправлено</span>
                                        </div>
                                        <!--<span v-show="pending">pending...</span>-->
                                        <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                              v-if="errors.has('common')">{{errors.get('common')}}</span>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div class="wsl-col-8_from-sm-12">
                        <div class="padding-testimonials-container">
                            <div class="padding-testimonials-slider wsl-p-b-20" style="line-height: 1.2">
                                <span class="Oswald-Light cb-cyan t48">С нами более <span
                                        class="cb-blue">4 000</span> агентств</span>

                                <swiper :options="swiperOption"
                                        class="wsl-p-b-60 wsl-m-x--15 testimonials-container"
                                        ref="mySwiper">
                                    <!-- slides -->
                                    <swiper-slide class="wsl-flex-ng">
                                        <div class="wsl-p-a-20 wsl-flex-ng">
                                            <div class="wsl-p-a-15 wsl-bg-white diplom-shadow Roboto cb-grey wsl-h-100">
                                                <div class="wsl-flex_from-md-Center-ng wsl-m-b-10">
                                                    <div class="wsl-col-nogrow_from-md-12_from-md-Center">
                                                        <img alt=""
                                                             src="../assets/img/wishtour.png">
                                                    </div>
                                                    <div class="wsl-col wsl-text-center">
                                                        <div class="wsl-p-x-5">
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">ООО «Виш Тур»</span><br>
                                                            <span class="Oswald-Light cb-blue t24">&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                Спасибо «CenterBooking.ru» за качественную, оперативную и удобную
                                                работу.
                                                Сотрудничаем уже более пяти лет, сначала порекомендовали коллеги по
                                                рекламному
                                                туру, попробовали и были приятно удивлены, насколько всё легко и
                                                понятно, а
                                                главное выгодно. Очень удобный личный кабинет. Особое преимущество при
                                                бронировании авиабилетов, подобрал перелёт, забронировал, выписал билет,
                                                отдал
                                                туристу документы, и сутки на оплату в «CenterBooking.ru». Несомненным
                                                плюсом
                                                является возможность оплачивать туристам картами напрямую в
                                                «CenterBooking.ru»
                                                через интернет эквайринг и минимальным процентом, нет необходимости
                                                подключать
                                                доп сервис в банке и иметь терминал в офисе. Так же очень приятны
                                                различные
                                                бонусы за регулярное и активное бронирование заявок.
                                                <br><br>
                                                С Уважением, ООО «Виш Тур» Обухова Татьяна
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide class="wsl-flex-ng">
                                        <div class="wsl-p-a-20 wsl-flex-ng">
                                            <div class="wsl-p-a-15 wsl-bg-white diplom-shadow Roboto cb-grey wsl-h-100">
                                                <div class="wsl-flex_from-md-Center-ng wsl-m-b-10">
                                                    <div class="wsl-col-nogrow_from-md-12_from-md-Center">
                                                        <img alt=""
                                                             src="../assets/img/aramzamzam.png">
                                                    </div>
                                                    <div class="wsl-col wsl-text-center">
                                                        <div class="wsl-p-x-5">
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">Aramzamzam</span><br>
                                                            <span class="Oswald-Light cb-blue t24">&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                Очень рады и благодарны долговременному, прозрачному и взаимовыгодному
                                                сотрудничеству с ЦентрБукинг.ру. Без преувеличений, это самый надежный и
                                                понятный партнер на рынке туризма на сегодняшний день в нашем регионе и
                                                стране!
                                                Мы сами работаем 9-й год в туризме и перепробовали модели работы
                                                практически
                                                всех подобных компаний, рады что своевременно ушли от взаимодействия с
                                                другими
                                                системами бронирования, которые работали без соблюдения предложенных ими
                                                гарантий по срокам оплат, правильности и оперативности обработки
                                                информации
                                                по
                                                заявкам. С ЦентрБукинг.ру все эти вопросы решены изначально и
                                                соблюдаются
                                                безоговорочно! Премного благодарны за взаимоуважение и качественное
                                                исполнение
                                                договоренностей! Будем сотрудничать и дальше для повышения качества
                                                услуг на
                                                рынке туризма!
                                                <br><br>
                                                С Уважением, директор Другова Наталья
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide class="wsl-flex-ng">
                                        <div class="wsl-p-a-20 wsl-flex-ng">
                                            <div class="wsl-p-a-15 wsl-bg-white diplom-shadow Roboto cb-grey wsl-h-100">
                                                <div class="wsl-flex_from-md-Center-ng wsl-m-b-10">
                                                    <div class="wsl-col-nogrow_from-md-12_from-md-Center">
                                                        <img alt=""
                                                             src="../assets/img/lori.png">
                                                    </div>
                                                    <div class="wsl-col wsl-text-center">
                                                        <div class="wsl-p-x-5">
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">ООО «Лори-Тур»</span><br>
                                                            <span class="Oswald-Light cb-blue t24">&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                Хотим выразить благодарность за продолжительное и плодотворное
                                                партнерство! Давно с вами сотрудничаем, все заявки обрабатываются быстро
                                                и профессионально. Удобно, что не надо заключать множество договоров с
                                                отдельными туроператорами. Простая и функциональная система
                                                бронирования, отличная бонусная программа. А возможность хранения денег
                                                на cashbox часто выручает при необходимости молниеносной оплаты заявок!
                                                <br><br>
                                                С уважением, ООО «Лори-Тур» Веселова Наталья.
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide class="wsl-flex-ng">
                                        <div class="wsl-p-a-20 wsl-flex-ng">
                                            <div class="wsl-p-a-15 wsl-bg-white diplom-shadow Roboto cb-grey wsl-h-100">
                                                <div class="wsl-flex_from-md-Center-ng wsl-m-b-10">
                                                    <div class="wsl-col-nogrow_from-md-12_from-md-Center">
                                                        <img alt=""
                                                             src="../assets/img/zabron.png">
                                                    </div>
                                                    <div class="wsl-col wsl-text-center">
                                                        <div class="wsl-p-x-5">
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">Забронь.ру</span><br>
                                                            <span class="Oswald-Light cb-blue t24">&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                Мы искренне благодарим CENTERBOOKING.RU за предоставление качественного
                                                сервиса для профессионального туристического рынка!

                                                На протяжении многих лет ваша компания проявляет себя надежным и
                                                добросовестным партнером, способным оперативно и на высоком уровне
                                                выполнять задачи и оптимизировать процессы по подбору и бронированию
                                                туров онлайн по всем туроператорам, а также по поиску и бронированию
                                                авиабилетов.

                                                Удобные способы оплаты, система учета расчетов и контроль отслеживания
                                                прохождения платежей туроператорам делают сотрудничество открытым и
                                                безопасным.

                                                Мы верим в сохранение деловых и уже дружеских отношений и надеемся на
                                                дальнейшее успешное и плодотворное сотрудничество!
                                                <br><br>
                                                С уважением, Ген. директор Плескачева С.В. «Забронь.ру»
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide class="wsl-flex-ng">
                                        <div class="wsl-p-a-20 wsl-flex-ng">
                                            <div class="wsl-p-a-15 wsl-bg-white diplom-shadow Roboto cb-grey wsl-h-100">
                                                <div class="wsl-flex_from-md-Center-ng wsl-m-b-10">
                                                    <div class="wsl-col-nogrow_from-md-12_from-md-Center">
                                                        <img alt=""
                                                             src="../assets/img/parmejan.png">
                                                    </div>
                                                    <div class="wsl-col wsl-text-center">
                                                        <div class="wsl-p-x-5">
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">Пармезан</span><br>
                                                            <span class="Oswald-Light cb-blue t24">&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                Турсистема «CENTERBOOKING.RU» - мой самый главный помощник и партнёр с
                                                момента открытия агентства. Здесь трудятся профессионалы, которые всегда
                                                готовы делиться своим опытом и знаниями. Работают четко и слаженно,
                                                полная поддержка и сопровождение турагентств. Отличная автоматизация
                                                всех процессов и множество технических "фишек", например,
                                                интернет-эквайринг с минимальной ставкой и авиакасса. Сотрудничать с
                                                ЦентрБукинг.Ру просто, удобно и выгодно. Спасибо, что вы есть!
                                                <br><br>
                                                С уважением, Юлия Полякова, "Пармезан"
                                            </div>
                                        </div>
                                    </swiper-slide>
                                    <swiper-slide class="wsl-flex-ng">
                                        <div class="wsl-p-a-20 wsl-flex-ng">
                                            <div class="wsl-p-a-15 wsl-bg-white diplom-shadow Roboto cb-grey wsl-h-100">
                                                <div class="wsl-flex_from-md-Center-ng wsl-m-b-10">
                                                    <div class="wsl-col-nogrow_from-md-12_from-md-Center">
                                                        <img alt=""
                                                             src="../assets/img/travelpoint.png">
                                                    </div>
                                                    <div class="wsl-col wsl-text-center">
                                                        <div class="wsl-p-x-5">
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">&nbsp;</span><br>
                                                            <span class="Oswald-Light cb-cyan t24">Travel Point</span><br>
                                                            <span class="Oswald-Light cb-blue t24">&nbsp;</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                ЦентрБукинг.ру всегда оперативен в работе и соблюдает поставленные сроки
                                                при заведении, обработке и оплате наших заявок. Это система, позволяющая
                                                работать с туристами, которые не могут придти в офис, тк имеется
                                                возможность направлять «страницу туриста», которая дает туристам
                                                самостоятельно оплачивать заявки.
                                                Все заявки в одном личном кабинете, это очень удобно.
                                                Вежливые и компетентные сотрудники, готовые в любое время ответить на
                                                возникающие вопросы и проконсультировать в случае непредвиденных и
                                                спорных ситуаций.
                                                Помимо уже озвученных положений существуют еще: удобный и интуитивно
                                                понятный интерфейс сайта; работа 24/7. Можем с уверенностью
                                                порекомендовать его всем тем, кто еще сомневается в выгоде подобной
                                                совместной работы.
                                                <br><br>
                                                С уважением, Директор Медведева Дарья
                                            </div>
                                        </div>
                                    </swiper-slide>

                                    <div class="swiper-pagination wsl-m-t-20" slot="pagination"
                                         style="bottom: 0px; right: 15px; left: auto;"></div>
                                </swiper>
                            </div>

                            <div class="wsl-p-y-20"></div>
                        </div>
                    </div>

                    <div class="wsl-col-12 padding-testimonials wsl-show-sm wsl-show-xs"
                         :style="{backgroundImage: `url(${blueBox})}`}"
                         style="
                        background-color: #4fb8fe;
                        background-repeat: no-repeat;
                        background-size: cover;
                        background-position: center center;
                        padding-top: 6.3%;
                        padding-left: 8%;
                        padding-right: 8%;">
                        <div class="" style="line-height: 1.2">
                            <span class="Oswald-Light cb-cyan t48">Остались вопросы?</span><br>
                            <span class="Oswald-Light cb-white t48">Мы будем рады</span>
                            <span class="Oswald-Light cb-white t48">пообщаться с вами</span>
                        </div>

                        <div class="wsl-m-t-40">
                            <form id="call_form_xs"
                                  novalidate="true">
                                <div class="">
                                    <div class="wsl-relative wsl-inline-block">
                                        <input id="name_xs"
                                               placeholder="Имя"
                                               v-model="name"
                                               v-on:input="hideError('name')"
                                               :disabled="pending"
                                               :readonly="pending"
                                               type="text"
                                               name="name">
                                        <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                              v-if="errors.has('name')">{{errors.get('name')}}</span>
                                    </div>
                                    <div class="wsl-relative wsl-inline-block wsl-m-t-20">
                                        <masked-input
                                                type="text"
                                                placeholder="+7 ( ___ ) ___ - __ - __"
                                                name="phone"
                                                class=""
                                                v-model="phone"
                                                :mask="['+','7',' ','(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/,'-', /\d/, /\d/]"
                                                :guide="true"
                                                placeholderChar="_">
                                        </masked-input>
                                        <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                              v-if="errors.has('phone')">{{errors.get('phone')}}</span>
                                    </div>
                                    <div class="wsl-relative wsl-inline-block wsl-m-t-20">
                                        <v-autocomplete :items="towns"
                                                        v-model="town"
                                                        :input-attrs="{
                                                            placeholder: 'Город',
                                                            id: 'town_xs',
                                                            class: '',
                                                            name: 'town',
                                                            type: 'text',
                                                            disabled: pending,
                                                            readonly: pending
                                                          }"
                                                        :get-label="getLabel"
                                                        :auto-select-one-item="false"
                                                        :wait="350"
                                                        :min-len="0"
                                                        @change="changeTown"
                                                        @update-items="updateItems">
                                        </v-autocomplete>
                                        <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                              v-if="errors.has('town')">{{errors.get('town')}}</span>
                                    </div>
                                </div>

                                <div class="wsl-m-b-50" style="margin-top: 60px;">
                                    <div class="wsl-small wsl-abs wsl-abs-right wsl-abs-bottom wsl-m-a-10">
                                        This site is protected by reCAPTCHA and the Google
                                        <a href="https://policies.google.com/privacy" target="_blank">Privacy Policy</a>
                                        and
                                        <a href="https://policies.google.com/terms" target="_blank">Terms of Service</a>
                                        apply.
                                    </div>
                                    <div class="wsl-flex-center-ng" style="width: 256px;">
                                        <div class="cb-btn-submit wsl-inline-block wsl-text-center"
                                             style="" v-on:click="submit"
                                             :class="{onclick: pending}">
                                            <span>Заказать звонок</span>
                                        </div>
                                        <!--<span v-show="pending">pending...</span>-->
                                        <span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t--15"
                                              v-if="errors.has('common')">{{errors.get('common')}}</span>
                                    </div>
                                    <!--<div class="cb-btn-blue wsl-inline-block z-depth-3 wsl-text-center"
                                         style="width: 256px; padding: 8px 0px;" v-on:click="checkForm">
                                        Заказать звонок
                                    </div>-->
                                    <!--<span v-show="pending">pending...</span>-->
                                    <!--<span class="wsl-red wsl-small wsl-abs wsl-abs-right wsl-abs-top wsl-m-t&#45;&#45;15"
                                        v-if="errors.has('common')">{{errors.get('common')}}</span>-->
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import towns from '@/assets/city.json'
import MaskedInput from 'vue-text-mask'

import townSelect from './town-select.vue'

export default {
  name: 'Section-08',
  props: {
    blueBox: String,
    s01Bg1: String
  },
  components: {
    MaskedInput
  },
  mounted () {
    this.reset()
    this.sended = false
    if (typeof window.grecaptcha === 'undefined') {
      /* var script = document.createElement('script')
            script.src = 'https://www.google.com/recaptcha/api.js?render=explicit'
            script.onload = this.renderWait
            document.head.appendChild(script) */
      let script = document.createElement('script')
      script.setAttribute('type', 'text/javascript')
      script.setAttribute('data-size', 'invisible')
      // recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=ru')
      script.setAttribute('src', 'https://www.google.com/recaptcha/api.js?render=' + this.sitekey + '&size=invisible')
      script.onload = this.renderWait
      // script.setAttribute('async', '')
      // script.setAttribute('defer', '')
      document.body.appendChild(script)
    } else {
      this.render()
    }
  },
  data () {
    return {
      sitekey: '6Lf6FIEUAAAAAIUVKpIjz72GDjcCRSUtVehUknM8',
      ready: false,
      towns: towns,
      touched: false,
      pending: false,
      sended: false,
      errors: new Map(),
      name: null,
      phone: null,
      town: null,
      city: null,
      townSelect: townSelect,
      swiperOption: {
        slidesPerView: 2,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 3500,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        breakpoints: {
          5000: {
            slidesPerView: 3
          },
          1600: {
            slidesPerView: 2
          },
          1366: {
            slidesPerView: 2
          },
          1280: {
            slidesPerView: 1
          },
          991: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 1
          },
          320: {
            slidesPerView: 1
          }
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    getLabel (item) {
      return item
    },
    updateItems (text) {
      console.log('update', text)
      // text = this.city
      // this.town = this.city
      this.towns = text ? towns.filter((item) => {
        /* return (new RegExp(text.toLowerCase())).test(item.toLowerCase())
              }) */
        const str = item.toLowerCase().trim()
        return text.toLowerCase().trim().split(' ').reduce((res, word) => {
          return res && str.indexOf(word) !== -1
        }, true)
      })/* .sort((a, b) => {
        if (args.sort) {
          return a[args.sort] > b[args.sort] ? 1 : a[args.sort] < b[args.sort] ? -1 : 0;
        }
        return 0
      }) */ : towns
    },
    hideError (name) {
      if (this.errors.has(name)) {
        this.errors.delete(name)
        this.errors = new Map(this.errors)
      }
      this.touched = true
    },
    changeTown (e) {
      console.log('changeTown', e)
      this.city = e
      this.hideError('town')
    },
    submit () {
      this.touched = true
      if (this.checkForm() && this.ready) {
        if (this.pending) {
          alert('подождите!')
        } else {
          this.send()
        }
      }
    },
    checkForm () {
      this.errors.clear()
      if (!this.touched) {
        return false
      }
      if (!this.name || this.name === '') {
        this.errors.set('name', 'Укажите имя')
      }
      if (!this.phone || this.phone === '') {
        this.errors.set('phone', 'Укажите телефон')
      }
      if (!this.town || this.town === '') {
        if (!this.city || this.city === '') {
          this.errors.set('town', 'Укажите город')
        } else {
          this.town = this.city
        }
      }
      if (!this.errors.size) {
        return true
      }
      this.errors = new Map(this.errors)
      //  e.preventDefault()
      return false
    },
    send () {
      this.pending = true
      this.sended = false
      window.grecaptcha.execute(this.sitekey, { action: 'landing' })
        .then((token) => {
          axios
            .get('/api/send_email', { params: { token, name: this.name, phone: this.phone, city: this.town } })
            .then(resp => {
              this.sended = true
              this.reset()
              setTimeout(() => {
                this.sended = false
              }, 2000)
            })
            .catch(() => {
              this.pending = false
              this.errors.set('common', 'Произошла ошибка. Попробуйте позже или обновите страницу F5')
              console.log(this.errors)
            })
        }, function () {
          this.pending = false
          this.errors.set('common', 'Произошла ошибка. Попробуйте позже или обновите страницу F5')
          console.log(this.errors)
        })
    },
    renderWait () {
      setTimeout(() => {
        if (typeof window.grecaptcha !== 'undefined' && typeof window.grecaptcha.render !== 'undefined') {
          this.render()
        } else {
          this.renderWait()
        }
      }, 200)
    },
    render () {
      window.grecaptcha.ready(() => {
        this.ready = true
      })
    },
    reset () {
      this.name = null
      this.phone = null
      this.town = null
      this.touched = false
      this.towns = towns
      this.errors = new Map()
      this.pending = false
    }
  }
}
</script>

<style scoped>

</style>
